import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { useUi } from "@/i18n/ui";
import { login as apiLogin, formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { lang, applyAuth } = useApp();
  const t = useUi(lang);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const data = await apiLogin(email, password);
      applyAuth(data.access_token, data.user);
      const staff = data.user?.role === "admin" || data.user?.role === "trainer" || data.user?.role === "hr";
      navigate(staff ? "/admin/users" : "/app");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rbl-auth-wrap" data-testid="login-page">
      <div className="rbl-auth-card">
        <img src="/logo_rbl.png" alt="RBL Training" style={{ height: 48 }} />
        <h1>{t("login")}</h1>
        <div className="sub">{t("loginSubtitle")}</div>
        {error && <div className="rbl-error" data-testid="login-error">{error}</div>}
        <form onSubmit={submit}>
          <div className="rbl-field">
            <label className="rbl-label">{t("email")}</label>
            <input className="rbl-input" type="email" autoComplete="email" data-testid="login-email"
              value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="rbl-field">
            <label className="rbl-label">{t("password")}</label>
            <input className="rbl-input" type="password" autoComplete="current-password" data-testid="login-password"
              value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <button className="rbl-btn block" type="submit" disabled={busy} data-testid="login-submit">
            {busy ? "…" : t("signIn")}
          </button>
        </form>
        <div className="rbl-auth-foot">
          <Link to="/forgot-password" className="rbl-link" data-testid="forgot-link">{t("forgotPassword")}</Link>
          <Link to="/" className="rbl-link" data-testid="login-back-hub">{t("backToHub")}</Link>
        </div>
      </div>
    </div>
  );
}
